import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'product_info-product_description_accordion_expand_about_this_product_section-click';
/**
 * Tracks retailer clicks to expand the &quot;About this product&quot; section of product details in Product Details Page
 */
export function trackProductInfoProductDescriptionAccordionExpandAboutThisProductSectionClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
